import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminShippingSettings() {
  const [form, setForm] = useState({ length_in: "", width_in: "", height_in: "", packaging_weight_oz: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient.get("/admin/settings/shipping").then((res) =>
      setForm({
        length_in: String(res.data.length_in),
        width_in: String(res.data.width_in),
        height_in: String(res.data.height_in),
        packaging_weight_oz: String(res.data.packaging_weight_oz),
      })
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await apiClient.put("/admin/settings/shipping", {
        length_in: parseFloat(form.length_in),
        width_in: parseFloat(form.width_in),
        height_in: parseFloat(form.height_in),
        packaging_weight_oz: parseFloat(form.packaging_weight_oz),
      });
      toast.success("Shipping package settings saved");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not save settings");
    } finally {
      setSaving(false);
    }
  };

  const field = (key, label) => (
    <div>
      <Label>{label}</Label>
      <Input
        type="number"
        min="0"
        step="0.1"
        required
        value={form[key]}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        data-testid={`shipping-settings-${key.replace(/_/g, "-")}`}
      />
    </div>
  );

  return (
    <div data-testid="admin-shipping-settings-page">
      <h1 className="text-2xl font-display font-semibold text-slate-900 mb-2">Shipping Settings</h1>
      <p className="text-sm text-slate-500 mb-6">
        Default package used to quote live rates at checkout and sent to ShipStation with every order.
        Product vial weights are set individually on each product.
      </p>
      <form onSubmit={handleSubmit} className="bg-white border border-slate-100 rounded-2xl p-6 max-w-xl space-y-5" data-testid="shipping-settings-form">
        <div>
          <p className="text-sm font-semibold text-slate-900 mb-3">Box Dimensions (inches)</p>
          <div className="grid grid-cols-3 gap-4">
            {field("length_in", "Length")}
            {field("width_in", "Width")}
            {field("height_in", "Height")}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4">
          {field("packaging_weight_oz", "Packaging Weight (oz)")}
        </div>
        <p className="text-xs text-slate-400">
          Total shipment weight = packaging weight + sum of each product's vial weight × quantity.
        </p>
        <Button type="submit" disabled={saving} className="rounded-md" data-testid="shipping-settings-save-btn">
          {saving ? "Saving..." : "Save Settings"}
        </Button>
      </form>
    </div>
  );
}
